/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_Not_SeatedInputs */



/**
* | output |
* | --- |
* | "Not seated" |
*
* @param {Rounds_Not_SeatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_not_seated = /** @type {((inputs?: Rounds_Not_SeatedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Not_SeatedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Non placé")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sin asiento")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não alocado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non seduto")
	return /** @type {LocalizedString} */ ("Not seated")
});